module.exports = __webpack_public_path__ + "img/logo-pwr.065742b0.svg";